import { FadeUp, Eyebrow } from "@/components/Reveal";

const rows = [
  ["Muslim community", "~99% — the adhan echoes through Stone Town's centuries-old alleys", "~35% nationwide; strong on the coast (Dar es Salaam, Tanga)"],
  ["Monthly budget (family of 4)", "$900 – $1,700", "$1,100 – $1,900 (Dar es Salaam)"],
  ["Schooling", "Small Islamic & private schools; few international options", "International & Islamic schools in Dar; much more choice"],
  ["Healthcare", "Limited — serious care means a flight to Dar or Nairobi", "Aga Khan Hospital in Dar; better specialists"],
  ["Pace of life", "Slow island rhythm; beach Fridays after Jumu'ah", "Big-city bustle; more jobs, services, and flights"],
  ["Best for", "Deep deen immersion and simple, salty living", "Families who need amenities, schools, and work options"],
];

export const TanzaniaSplit = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pb-16 lg:pb-24" data-testid="tanzania-split">
    <FadeUp>
      <Eyebrow>One country, two very different lives</Eyebrow>
      <h2 className="mt-4 font-serif font-semibold text-ink text-3xl lg:text-5xl leading-tight max-w-2xl">
        Zanzibar <span className="italic text-petal">vs</span> the Mainland — where do you land?
      </h2>
      <p className="mt-5 text-sage max-w-2xl leading-relaxed">
        Most hijrah families choose between the spice island's soulful Muslim bubble and Dar es Salaam's practical city life. Here's the honest split:
      </p>
    </FadeUp>

    <FadeUp className="mt-10 bg-white rounded-3xl border border-pine/10 shadow-sm overflow-hidden">
      <div className="grid grid-cols-[1fr_1.2fr_1.2fr] border-b border-pine/10">
        <div className="px-5 py-5" />
        <div className="px-5 py-5 border-l border-pine/10 bg-blush">
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-petal">The Island</p>
          <p className="font-serif font-semibold text-xl text-pine">Zanzibar</p>
        </div>
        <div className="px-5 py-5 border-l border-pine/10">
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-sage">The Mainland</p>
          <p className="font-serif font-semibold text-xl text-pine">Dar & beyond</p>
        </div>
      </div>
      {rows.map(([label, zan, main], i) => (
        <div key={label} className={`grid grid-cols-[1fr_1.2fr_1.2fr] ${i % 2 ? "bg-blush/40" : ""}`} data-testid={`tanzania-row-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
          <div className="px-5 py-4 font-mono text-[10px] sm:text-xs tracking-widest uppercase text-sage flex items-center">{label}</div>
          <div className="px-5 py-4 border-l border-pine/10 text-sm text-ink/85 leading-relaxed bg-blush/60">{zan}</div>
          <div className="px-5 py-4 border-l border-pine/10 text-sm text-ink/85 leading-relaxed">{main}</div>
        </div>
      ))}
      <div className="px-5 py-4 border-t border-pine/10 bg-pine-ink text-cream">
        <p className="text-sm leading-relaxed">
          <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-petal-soft block mb-1">Mom's shortcut</span>
          Scout Dar first for schools and hospitals, then take the 2-hour ferry to Zanzibar and see if the island steals your heart. Many families split the year between both.
        </p>
      </div>
    </FadeUp>
  </section>
);
